import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import * as ApiPaths from "../enums/ApiPaths";
import logger from "../utils/logger";

class WebSocketService {
  constructor(token, path, clinicId) {
    this.clinicId = clinicId;
    this.path = path
    this.client = new Client({
      brokerURL: ApiPaths.WS_BASE_URL,
      connectHeaders: token,
      debug: (str) => {},
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      webSocketFactory: () => {
        const sockJS = new SockJS(ApiPaths.WS_BASE_URL);
        sockJS.withCredentials = true;
        return sockJS;
      },
    });
  }

  connect(callback) {
    this.client.onConnect = (frame) => {
      this.client.subscribe(
        `/topic/notifications/${this.path}/${this.clinicId}`,
        (message) => {
          callback(JSON.parse(message.body));
        }
      );
    };

    this.client.onStompError = (frame) => {
      logger.error("WebSocket STOMP error:", frame.headers?.message, frame.body);
    };

    this.client.activate();
  }

  disconnect() {
    if (this.client) {
      this.client.deactivate();
    }
  }
}

export default WebSocketService;
